import React from 'react';
import { useAuth } from '@contexts/AuthContext';
import InternalSettings from '@pages/clinic-admin/components/InternalSettings';
import SettingsPage from '@pages/client/components/ClientSettings';

/**
 * /settings: client — setări cont client; staff — setări interne clinică (component existent).
 */
const RoleAwareSettings: React.FC = () => {
  const { user } = useAuth();
  if (user?.role === 'client') {
    return <SettingsPage />;
  }
  return <InternalSettings />;
};

export default RoleAwareSettings;
